import { render, staticRenderFns } from "./bioshopall.vue?vue&type=template&id=68d0356c&"
import script from "./bioshopall.vue?vue&type=script&lang=js&"
export * from "./bioshopall.vue?vue&type=script&lang=js&"
import style0 from "./bioshopall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports